import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { Box, TextField } from '@mui/material';
// import CKEditor from 'ckeditor4-react';
import { useState, Downgraded, createState } from '@hookstate/core';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import validator from 'validator';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';

const settingState = createState({
    userID: 0,
    emailID: '',
    ccEmailID: '',
    bccEmailID: '',
    body: '',
    subject: '',
    siteUrl: ''
});

const SendBulkUserInvitationEmail = (props) => {
    const state = useState(settingState);
    // const invitationtemplateInfo = useState(null);
    const userInfo = useState(null);
    const eventData = useState(null);
    const [ccEmailErr, setCCEmailErr] = React.useState('');
    const [bccEmailErr, setBCCEmailErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    let params = useParams();
    const [loading, setLoading] = React.useState(false);
    const showLoading = true;
    const [snackBar, setSnackBar] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }

        if (props.emailIds) {
            const emailObj = props.emailIds.map((item) => {
                return item.email;
            });
            ApiHelper.get(
                APIURLConstants.GET_CONFIG()
            ).then((res) => {
                if (res.data) {
                    let actualData = res.data;
                    let configObj = {
                        // userID: actualData.userID,
                        emailID: emailObj.join(','),
                        ccEmailID: actualData.ccEmail ? actualData.ccEmail : '',
                        bccEmailID: actualData.bccEmail ? actualData.bccEmail : '',
                        body: actualData.body,
                        subject: actualData.subject,
                        siteUrl: actualData.siteURL,
                    };
                    state.set(configObj);
                }
            });
        }
    }, []);

    const isEmailValidate = () => {
        let flag = true;
        const email =
            state.emailID.attach(Downgraded).get() != null
                ? state.emailID.attach(Downgraded).get().trim()
                : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setEmailErr('')
                    : setEmailErr('Please enter valid To Email');
            });
        } else setEmailErr('');
        return flag;
    };

    const isCCEmailValidate = () => {
        let flag = true;
        const email =
            state.ccEmailID.attach(Downgraded).get() != null
                ? state.ccEmailID.attach(Downgraded).get().trim()
                : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setCCEmailErr('')
                    : setCCEmailErr('Please enter valid CC Email');
            });
        } else setCCEmailErr('');
        return flag;
    };

    const isBCCEmailValidate = () => {
        let flag = true;
        const email =
            state.bccEmailID.attach(Downgraded).get() != null
                ? state.bccEmailID.attach(Downgraded).get().trim()
                : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setBCCEmailErr('')
                    : setBCCEmailErr('Please enter valid BCC Email');
            });
        } else setBCCEmailErr('');
        return flag;
    };

    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };
    const setEditorValue = (value) => {
        state.body.set(value);
    }
    const renderDialogContent = () => {
        return (
            <>
                <Box>
                    <Box>
                        <TextField
                            fullWidth
                            // sx={{
                            //     marginTop: 2,
                            //     marginRight: 2,
                            // }}
                            size="small"
                            id="outlined-required"
                            label="To"
                            inputProps={
                                { readOnly: true, }
                            }
                            value={state.emailID.get()}
                            onChange={(e) => {
                                state.emailID.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isEmailValidate()
                            }
                            error={emailErr.length > 0 ? true : false}
                            helperText={emailErr.length > 0 ? emailErr : ''}
                        />
                    </Box>
                    <Box sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: 2,
                            }}
                            value={state.ccEmailID.get()}
                            size="small"
                            id="outlined-required"
                            label="CC"
                            onChange={(e) => {
                                state.ccEmailID.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isCCEmailValidate()
                            }
                            error={ccEmailErr.length > 0 ? true : false}
                            helperText={ccEmailErr.length > 0 ? ccEmailErr : ''}
                        />
                    </Box>
                    <Box sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: 2,
                            }}
                            value={state.bccEmailID.get()}
                            size="small"
                            id="outlined-required"
                            label="BCC"
                            onChange={(e) => {
                                state.bccEmailID.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isBCCEmailValidate()
                            }
                            error={bccEmailErr.length > 0 ? true : false}
                            helperText={
                                bccEmailErr.length > 0 ? bccEmailErr : ''
                            }
                        />
                    </Box>

                    <Box sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            required
                            sx={{
                                marginRight: 2,
                            }}
                            size="small"
                            value={state.subject.get()}
                            onChange={(e) => {
                                state.subject.set(e.target.value);
                            }}
                            id="outlined-required"
                            label="Subject"
                        />
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            flexDirection: 'row',
                            marginTop: 2,
                            width: { xs: '100%', md: '100%' },
                        }}>
                        {/* <CKEditor
                            config={{
                                removeButtons: 'Subscript,Superscript',
                                enterMode: 3,
                                allowedContent: true,
                                extraAllowedContent: '*{*};*(*);span{!color}'
                            }}
                            data={state.body.attach(Downgraded).get()}
                            onChange={(event) =>
                                state.body.set(event.editor.getData())
                            }
                        /> */}
                        <TinyMCEEditor
                            value={state.body.attach(Downgraded).get()}
                            setValue={setEditorValue}                
                        />
                        {/* <CKEditor
                            editor={Editor}
                            config={{
                                image: {
                                    upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                                },
                                enterMode: 3
                            }}
                            data={state.body.attach(Downgraded).get()}
                            onChange={(event, editor) => {
                                console.log(event);
                                state.body.set(editor.getData())
                            }}
                        /> */}
                    </Box>
                </Box>
            </>
        );
    };

    const renderDialogActions = () => {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={'Send'}
                loading={loading}
                showLoading={showLoading}
            />
        );
    };
    const handleClick = async () => {
        const toValid = isEmailValidate();
        const ccValid = isCCEmailValidate();
        const bccValid = isBCCEmailValidate();
        // console.log(toValid, ccValid, bccValid);
        if (ccValid == false || bccValid == false || toValid == false) {
            return false;
        }
        if (
            (isEmpty(state.get().emailID) ||
                state.get().emailID == undefined) &&
            (isEmpty(state.get().ccEmailID) ||
                state.get().ccEmailID == undefined) &&
            (isEmpty(state.get().bccEmailID) ||
                state.get().bccEmailID == undefined)
        ) {
            let message =
                'We need to know who to send this to. Make sure you enter at least one name.';

            setSnackBar({
                // ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: message,
            });
            return false;
        }
        if (isEmpty(state.get().subject) || state.get().subject == undefined) {
            let message = 'Please fill out subject';

            setSnackBar({
                // ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: message, //'Error while Send Email',
            });
            return false;
        }
        props.emailIds.map((item, i) => {
            let formData = new FormData();
            // //Adding files to the form data
            formData.append('UserID', item.userID);
            formData.append('EmailID', item.email);
            formData.append('FirstName', item.firstName);
            formData.append('LastName', item.lastName);
            formData.append('CCEmailID', state.get().ccEmailID);
            formData.append('BCCEmailID', state.get().bccEmailID);
            formData.append('Body', state.get().body);
            formData.append('SiteURL', state.get().siteUrl);
            formData.append('Subject', state.get().subject);
            formData.append('modifiedBy', userInfo.attach(Downgraded).get().userID);
            setLoading(true);
            ApiHelper.post(APIURLConstants.POST_SEND_USER_INVITATION_EMAIL, formData)
                .then((res) => {
                    if (res.data) {
                         setLoading(false);
                        if (i === 0) { 
                            if (res.data == 'Email Sent successfully') {
                                props.setSnackBarProps({
                                    ...props.snackBarProps,
                                    openSnack: true,
                                    variant: 'success',
                                    message: 'Email Sent successfully',
                                });
                                props.handleClose();
                                setTimeout(() => {
                                    if (props.emailIds) {
                                        props.getUsersList();
                                    }
                                }, 1000);
                            } else {
                                props.setSnackBarProps({
                                    ...props.snackBarProps,
                                    openSnack: true,
                                    variant: 'error',
                                    message: 'Email Sent Failed',
                                });
                            }

                        }
                    }

                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error);
                    var msg = 'Error while Send Email';
                    if (error.response.data == 'Please add subject Or body')
                        msg = 'Please add subject Or body';
                    if (error.response && error.response.status === 401) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: msg, //'Error while Send Email',
                        });
                    }
                });
        })

    };

    return (
        <>
            <CustomDialog
                title={props.title}
                handleClose={props.handleclose}
                open={props.open}
                fullWidth={true}
                maxWidth={'lg'}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}
            // snackBarProps={snackBar}
            // setSnackBarProps={setSnackBar}
            />
            {snackBar.openSnack && (
                <CustomizedSnackbars
                    {...snackBar}
                    onClose={() =>
                        setSnackBar({ ...snackBar, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </>
    );
};
export default SendBulkUserInvitationEmail;
